<template>
  <div class="login_box_all">
    <div class="login_box_content">
      <div class="text-center login_title login_titleBox">
        <img src="../../assets/images/login_logo.png" />《{{
          $store.state.Name
        }}》Online Submission System — <span>User Register</span>
      </div>
      <Parvacy v-show="!num" />
      <Reg v-show="num" />
    </div>
    <MasterButtom></MasterButtom>
  </div>
</template>

<script>
import Parvacy from './pravacy.vue'
import Reg from './reg.vue'
import MasterButtom from '../../components/MasterButtom'
export default {
  name: 'regist',
  components: { Parvacy, Reg, MasterButtom },
  data() {
    return {
      num: false,
    }
  },
  deactivated() {
    this.num = false
  },
  mounted() {},
}
</script>

<style scoped></style>
